import { AxiosResponse } from "axios";
import { PlayerStatusRequest, PlayerStatusModel, LoginRequest, TokenModel } from "../../models/login-models";
import { playDigitalClientV1 } from "../../play-digital-client-v1";

export async function fetchPlayerStatus(userName: string): Promise<PlayerStatusModel> {
    const response = await playDigitalClientV1.post<PlayerStatusModel, AxiosResponse<PlayerStatusModel>, PlayerStatusRequest>(
        "/players/fetch",
        {
            type: "PHONE",
            value: userName,
        },
    );

    return response.data;
}

export async function callLogin(userName: string, password: string): Promise<TokenModel[]> {
    const response = await playDigitalClientV1.post<TokenModel[], AxiosResponse<TokenModel[]>, LoginRequest>("/oauth/login", {
        siteId: 98,
        clientId: "SazkaPortal",
        resourceOwnerCredentials: {
            USERNAME: userName,
            PASSWORD: password,
        },
    });

    return response.data;
}

export const logoutUrl = "/oauth/self/tokens/";
export async function callLogout(token: string): Promise<void> {
    await playDigitalClientV1.delete<void>(logoutUrl + token);
}

export async function callOtpRequest(userName: string): Promise<void> {
    await playDigitalClientV1.post<void, AxiosResponse<void>, LoginRequest>("/oauth/otp/generate", {
        siteId: 98,
        clientId: "SazkaPortal",
        resourceOwnerCredentials: {
            USERNAME: userName,
        },
    });
}
